/* eslint max-statements: 0 no-nested-ternary: 0 */

(function () {

  var kMaxInAppCookieSizeBytes = 1024;
  var kInAppCookiePersistTimeMs = 30 * 60 * 1000;    // 30 minutes


  function urlPathCompress(url) {

    var hostIdx = url.indexOf(requestContext.hostPath);
    var path = url.substr(hostIdx + requestContext.hostPath.length);

    var search = '/search?';
    if (path.indexOf(search) === 0) {
      path = path.substr(search.length);
    } else {
      var idx = path.lastIndexOf('#');
      if (idx !== -1) {
        path = path.substr(0, idx);
      }

      idx = path.lastIndexOf('-');
      if (idx !== -1) {
        path = path.substr(idx + 1);
      }
    }

    return path;
  }

  function urlPathExpand(url) {
    if (url.indexOf('q=') === 0) {
      return '/search?' + url;
    }

    return '/-' + url;

  }

  function readInappData() {
    var gdinapp = JSON.parse(ux.utils.cookie.get('gdinapp') || null);
    if (!gdinapp) {
      gdinapp = {
        history: []
      };
    }
    return gdinapp;
  }

  function updateNavVisible(gdinapp) {
    if (gdinapp.history.length > 1) {
      $('.inapp-back').removeClass('disabled');
    } else {
      $('.inapp-back').addClass('disabled');
    }
  }

  function updateSpellingVisible() {
    var spelling = $('.showing-results-for');
    if (spelling.length) {
      spelling.show();
    }
  }

  function getRootDomain() {
    if (!window || !window.location) { return ''; }

    const hostname = window.location.hostname;
    if (hostname) {
      const parts = hostname.split('.');
      const domain = parts.slice(parts.length - 2).join('.');
      return '.' + domain;
    }

    return '';
  }

  function writeInappData(gdinapp) {

    var size = 0;
    for (var i = 0; i < gdinapp.history.length; i++) {
      var item = gdinapp.history[i];
      size += item.length;
    }

    // remove older history when needed to keep cookie size bounded
    if (size > kMaxInAppCookieSizeBytes) {
      gdinapp.history.splice(1, 1);
    }

    var expDate = new Date(Date.now() + kInAppCookiePersistTimeMs);
    ux.utils.cookie.set('gdinapp', JSON.stringify(gdinapp), {
      domain: getRootDomain(),
      path: '/',
      expires: expDate.toUTCString()
    });
  }

  function getIEVersion() {
    var userAgent = navigator.userAgent.toLowerCase();
    // eslint-disable-next-line radix
    return (userAgent.indexOf('msie') !== -1) ? parseInt(userAgent.split('msie')[1]) : 0;
  }

  // IE9 does not display the mobile view inside the iframe.
  // This would set width to 100% and hide the remaining elements from the view.
  function fixLayoutIfIE9() {
    if (getIEVersion() === 9) {
      // Fixing the header
      $('.ux-pagetitle div[class^="col-md-"]').each(function () {
        $(this).attr('class', '').addClass('col-md-12');
      });

      // Fixing the products
      $('a:has(> .help-display-ad)').hide();
      $('.vault-actions').hide();
      $('.ie9-inapp-help-fix').removeClass('col-lg-8').addClass('col-lg-12');

      // Fixing the community integration
      $('.top-solutions .col-lg-4').each(function () {
        $(this).removeClass('col-lg-4').addClass('col-lg-12');
      });
    }
  }

  function initInappHelp() {
    var gdinapp = readInappData();

    if (requestContext.inappFlag === 'true') {
      if (requestContext.reopenLast !== 'true') {
        gdinapp = { history: [] };
      }

      if (gdinapp.history.length === 0) {
        var inappHome = window.location.href.split('?');
        gdinapp.history.push(urlPathCompress(inappHome[0]));
        writeInappData(gdinapp);
      }
    }

    updateNavVisible(gdinapp);
    updateSpellingVisible();
    fixLayoutIfIE9();
  }

  function endsWith(suffix, str) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
  }

  function inappHistoryAdd(url) {
    if (!url || endsWith('#', url)) { return; }
    var gdinapp = readInappData();
    var newItem = urlPathCompress(url);

    if (gdinapp.history.length && gdinapp.history[gdinapp.history.length - 1] === newItem) {
      return;
    }

    gdinapp.history.push(newItem);
    writeInappData(gdinapp);
  }

  function isExternalUrl(url) {
    return (url.indexOf(requestContext.hostPath) === -1);
  }

  function isProductItem(item) {
    var obj = $(item);
    return (obj.hasClass('top-help-product') || obj.hasClass('help-product-link'));
  }

  function anchorOnClick() {
    var url = this.href;
    if (!url) { return true; }

    if (gdhelp2.utils.inIframe() && isExternalUrl(url)) {
      window.open(url);
      return false;
    }

    if (gdhelp2.utils.inIframe()) {
      inappHistoryAdd(url);
    }

    if (isProductItem(this)) {
      return false;
    }

    return true;


  }

  function anchorOnTouchStart() {
    if (isProductItem(this)) {
      this.href = '';  // prevent touch drag/swipte from link open
    }
    return true;
  }

  function getUsrinData() {
    return [
      ['url', window.location.href],
      ['plId', requestContext.plId]
    ];
  }

  function inappNavBack() {
    var gdinapp = readInappData();
    if (gdinapp.history.length > 1) {
      ux.traffic.custom('inapp-back',
        'mcx.help.inapp.nav.back',
        getUsrinData());
      setTimeout(function () {
        gdinapp.history.pop();
        writeInappData(gdinapp);
        var prevUrl = requestContext.hostPath +
          urlPathExpand(gdinapp.history[gdinapp.history.length - 1]);
        window.location.href = prevUrl;
      }, 100);
    }
    return false;
  }

  function inappNavHome() {
    var gdinapp = readInappData();
    if (gdinapp.history.length) {
      ux.traffic.custom('inapp-home',
        'mcx.help.inapp.nav.home',
        getUsrinData());
      setTimeout(function () {
        var home = gdinapp.history[0];
        gdinapp = { history: [] };
        gdinapp.history.push(home);
        writeInappData(gdinapp);
        window.location.href = requestContext.hostPath +
          urlPathExpand(gdinapp.history[0]);
      }, 100);
    }
    return false;
  }

  function notifySearch(url) {
    inappHistoryAdd(url);
  }

  function ready() {
    if (gdhelp2.utils.inIframe()) {
      initInappHelp();
    }
  }

  if (!window.gdInappHelp) {
    window.gdInappHelp = {};
  }
  window.gdInappHelp.notifySearch = notifySearch;

  $('a').on('click', anchorOnClick);
  $('a').on('touchstart', anchorOnTouchStart);
  $('#inapp-nav-back').on('click', inappNavBack);
  $('#inapp-nav-back-icon').on('click', inappNavBack);
  $('#inapp-nav-home').on('click', inappNavHome);
  $(document).ready(ready);

}());
